import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { searchClubs } from './thunks'
import { editClub, deactivateClub, reactivateClub } from '../club/thunks'

const initialState: Clubs = {
  clubs: [],
  status: 'idle',
  error: null,
  searchFilters: {},
}

const slice = createSlice({
  name: 'clubs',
  initialState,
  reducers: {
    clearClubs: (state) => {
      state.clubs = []
      state.status = 'idle'
      state.error = null
    },
    saveSearchFilters: (state, action) => {
      state.searchFilters = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchClubs.pending, (state, action) => {
        state.status = 'loading'
        state.error = null
        const { offset } = action.meta.arg.data
        const isFirstFetch = [0, undefined].includes(offset)
        if (isFirstFetch) {
          state.clubs = []
        }
      })
      .addCase(searchClubs.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(searchClubs.fulfilled, (state, action) => {
        state.status = 'succeeded'
        const { offset } = action.meta.arg.data
        const isFirstFetch = [0, undefined].includes(offset)
        state.clubs = isFirstFetch ? action.payload : state.clubs.concat(action.payload)
      })

    builder.addCase(editClub.fulfilled, (state, action) => {
      const updatedId = action.payload.id
      const currentIndex = state.clubs.map((club: Club) => club.id).indexOf(updatedId)
      const originalClub = state.clubs[currentIndex]
      state.clubs[currentIndex] = { ...originalClub, ...action.payload }
      state.clubs[currentIndex].courses = originalClub?.courses ?? []
    })

    builder.addCase(deactivateClub.fulfilled, (state, action) => {
      const updatedId = action.payload.id
      const currentIndex = state.clubs.map((club: Club) => club.id).indexOf(updatedId)
      const originalClub = state.clubs[currentIndex]
      state.clubs[currentIndex] = { ...originalClub, ...action.payload }
      state.clubs[currentIndex].courses = originalClub?.courses ?? []
    })

    builder.addCase(reactivateClub.fulfilled, (state, action) => {
      const updatedId = action.payload.id
      const currentIndex = state.clubs.map((club: Club) => club.id).indexOf(updatedId)
      const originalClub = state.clubs[currentIndex]
      state.clubs[currentIndex] = { ...originalClub, ...action.payload }
      state.clubs[currentIndex].courses = originalClub.courses ?? []
    })
  },
})

export const { clearClubs, saveSearchFilters } = slice.actions

export const selectClubs = (state: RootState): Clubs => state.clubs

export default slice.reducer
